export default "__VITE_ASSET__BLleXnVt__"